import React from 'react'
import './Neon.css'

const Neon = () => {
    return (
        <div className='containerNeon'>
            <h1>Life is<span class="fantastic"> Fantastic</span></h1>
        </div>
    )
}

export default Neon
